import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import 'normalize.css';
import { ConfigProvider } from 'antd';
import './index.scss';

ReactDOM.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#7438F2',
        borderRadius: 5,
        colorBgContainer: '#fff',
        fontFamily: 'Poppins',
        colorPrimaryHover: '#5e1aed'
      }
    }}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
